import React, { Component } from 'react';
import 'assets/css/geral.css';
import { Dialog as DialogPrime } from 'primereact/dialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import Parser from 'html-react-parser';
import Anotacao from './Anotacao';
import { dominioDemandaCirurgica, dominioNODE } from '../../config/database';
import ItensPedidoCirurgia from './ItensPedidoCirurgia';
import DetalhesAnestesia from './DetalhesAnestesia';

class BotaoCheckList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      abreModalparecer: false,
      listaParecer: [],
      parecerSelecionado: null,
      configuracoes: {},
      motivoParecer: null,
      abreAnotacoes: false,
      itensPedidoCirurgia: [],
      listaStatusItens: [],
      ehAnestesia: false,
      detalhesAnestesia: null,
    };
  }

  handleDarParecer = () => {
    let itensPedidoCirurgia = [];
    let listaStatusItens = [];

    const { areaTecnica_id } = JSON.parse(localStorage.getItem('profissional'));
    const { areaTecnicaAnestesia } = JSON.parse(localStorage.getItem('configuracoes'));

    const ehAnestesia = areaTecnica_id === areaTecnicaAnestesia;

    this.setState({ ehAnestesia });

    let url = '';

    if (ehAnestesia) url = `/api/detalhesParecerAnestesia/${this.props.pedido.id}`;
    else url = `/api/itensParecerAreaTecnica/${this.props.area.id}/${this.props.pedido.id}`;

    dominioDemandaCirurgica.get(url).then(res => {
      if (!ehAnestesia) {
        itensPedidoCirurgia = res.data;
        listaStatusItens = itensPedidoCirurgia
          .map(item => {
            return {
              cor: item.cor,
              descricao: item.descricao_status,
            };
          })
          .filter(status => Boolean(status.cor));
        listaStatusItens = [
          ...new Map(listaStatusItens.map(item => [item.descricao, item])).values(),
        ];

        this.setState({ itensPedidoCirurgia, listaStatusItens });
      } else {
        this.setState({ detalhesAnestesia: res.data });
      }
    });

    this.setState({ abreModalparecer: true });
  };

  carregarListaParecer = () => {
    dominioDemandaCirurgica.get(`/api/parecerTecnicoCheckList`).then(res => {
      this.setState({
        listaParecer: res.data,
      });
    });
  };

  handleGravarParecer() {
    const profissional = JSON.parse(localStorage.getItem('profissional'));

    if (
      this.state.parecerSelecionado.id === this.props.configuracoes.parecerRejeicao ||
      this.state.parecerSelecionado.id === this.props.configuracoes.parecerPendente
    ) {
      if (this.state.motivoParecer === null || this.state.motivoParecer === '') {
        alert('Para rejeição ou pendência o parecer é obrigatório');
        return;
      }
    }

    const dadosParecer = {
      justificativa: this.state.motivoParecer ? this.state.motivoParecer : '-',
      areaTecnica: profissional.areaTecnica_id,
      pedidoCirurgia: this.props.pedido.id,
      parecerTecnico: this.state.parecerSelecionado.id,
    };
    dominioDemandaCirurgica
      .post('/api/parecerAreaTecnica', dadosParecer)
      .then(() => {
        this.setState({
          abreModalparecer: false,
        });
        this.props.listarPedidosCirurgia();
      })
      .then(() => {
        const dataLog = {
          id_usuario: profissional.userid,
          username: profissional.username,
          id_pedido: this.props.pedido.id,
          tipo: 'Parecer',
          descricao: `(${this.state.parecerSelecionado.descricao}) - ${this.state.motivoParecer}`,
        };
        dominioNODE.post('/logpedido', dataLog).catch(error => {
          console.log(`ERRO AO INCLUIR LOG: ${error}`);
        });
      });
  }

  render() {
    return (
      <>
        <DialogPrime
          header={`Pedido nº  ${this.props.pedido.codigo}`}
          visible={this.state.abreModalparecer}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreModalparecer: false })}
          onShow={() => this.carregarListaParecer()}
        >
          <div className="div-convenio-parecer">
            <strong>{`${this.props.pedido.nomeConvenio}`}</strong>
          </div>
          <h4>{this.props.pedido.paciente}</h4>
          {this.state.ehAnestesia ? (
            <DetalhesAnestesia detalhes={this.state.detalhesAnestesia} />
          ) : (
            <ItensPedidoCirurgia
              itensPedidoCirurgia={this.state.itensPedidoCirurgia}
              listaStatusItens={this.state.listaStatusItens}
            />
          )}
          <Autocomplete
            id="filtroPrioridade"
            options={this.state.listaParecer}
            style={{ marginBottom: '20px', marginTop: '10px' }}
            getOptionLabel={option => `${option.descricao}`}
            onChange={(e, value) => {
              this.setState({ parecerSelecionado: value });
            }}
            value={this.state.parecerSelecionado}
            filterSelectedOptions
            renderInput={params => (
              <TextField {...params} label="Selecione o parecer" variant="outlined" />
            )}
          />

          <div>
            <TextField
              id="descricaoParecer"
              multiline
              onChange={e => {
                this.setState({ motivoParecer: e.target.value });
              }}
              style={{ marginBottom: '20px', marginTop: '10px', textAlign: 'left' }}
              inputProps={{ maxLength: '4000' }}
              label="Descreva o parecer"
              variant="outlined"
              fullWidth
              rows={3}
            />
            <div style={{ float: 'right' }}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '5px', marginBottom: '15px' }}
                onClick={() => this.setState({ abreAnotacoes: true })}
              >
                Anotações
              </Button>
              <Button
                style={{ marginBottom: '15px' }}
                variant="contained"
                color="secondary"
                onClick={() => this.handleGravarParecer()}
              >
                Confirmar
              </Button>
              <br />
            </div>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Anotações"
          visible={this.state.abreAnotacoes}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAnotacoes: false })}
        >
          <>
            <Anotacao pedidoCirurgia={this.props.pedido.id} />
          </>
        </DialogPrime>
        {((this.props.parecer.parecerTecnico &&
          this.props.parecer.parecerTecnico.id !==
            this.props.configuracoes.parecerAprovacaoSistema) ||
          this.props.configuracoes.areasTecnicasSemBloqueioParecer.includes(this.props.area.id) ||
          !this.props.parecer.parecerTecnico) &&
        this.props.pedido.status_id !== this.props.configuracoes.statusFinalizado ? (
          <>
            <Tooltip
              title={
                <>
                  <h5>{this.props.parecer.areaTecnica.descricao}</h5>
                  <p style={{ wordWrap: 'break-word' }}>
                    {Parser(String(this.props.parecer.justificativa))}
                  </p>
                </>
              }
            >
              <a href="#" onClick={() => this.handleDarParecer()}>
                <span
                  className="bolinha-checklist"
                  style={{
                    backgroundColor: this.props.parecer.parecerTecnico
                      ? this.props.parecer.parecerTecnico.cor
                      : 'lightgray',
                  }}
                />
              </a>
            </Tooltip>
          </>
        ) : (
          <div>
            <Tooltip
              title={
                <>
                  <h5>{this.props.parecer.areaTecnica.descricao}</h5>
                  <p style={{ wordWrap: 'break-word' }}>
                    {Parser(String(this.props.parecer.justificativa))}
                  </p>
                </>
              }
            >
              <span
                className="bolinha-checklist"
                style={{
                  backgroundColor: this.props.parecer.parecerTecnico
                    ? this.props.parecer.parecerTecnico.cor
                    : 'lightgray',
                }}
              />
            </Tooltip>
          </div>
        )}
      </>
    );
  }
}

export default BotaoCheckList;
